import axios from 'axios'
import { apiClient, createHydraRequest, toHydraHref } from './api'

// ============================================
// Auth Services
// ============================================

export const login = ({ userHash }: { userHash: string }) => {
    return apiClient.post('/getSignin', {
        user: userHash,
        type: 'employees'
    })
}

// ============================================
// Distributor Services
// ============================================

export const checkBAID = ({ baid }: { baid: string }) => {
    return apiClient.post('/checkbaid', { baid })
}

export const getDistributorInformation = ({ distid, cstoken }: { distid: string; cstoken: string }) => {
    return apiClient.post('/viewba_feed', { distid, cstoken })
}

// ============================================
// Order History Services
// ============================================

type TOrderHistoryParams = {
    cstoken: string
    baHrefBase64: string
    dateStart?: string
}

export const getOrderHistory = ({ cstoken, baHrefBase64, dateStart }: TOrderHistoryParams) => {
    const data: Record<string, string> = {
        baToken: cstoken,
        baHref: baHrefBase64
    }

    if (dateStart) {
        data.dateStart = dateStart
    }

    return apiClient.post('/orderHistory', data)
}

// ============================================
// Commission Services
// ============================================

export const getCommission = ({ token, href }: { token: string; href: string }) => {
    return apiClient.post('/commission_ajax', { token, href })
}

// ============================================
// Genealogy Services
// ============================================

type TGenealogyParams = {
    href: string
    maxTreeDepth: string
    token: string
}

export const getGenealogy = ({ href, maxTreeDepth, token }: TGenealogyParams) => {
    return apiClient.post('/getGenology', { href, maxTreeDepth, token })
}

// ============================================
// View BA Details Services (Hydra API)
// ============================================

type TViewBADetailsParams = {
    token: string
    href: string
    queryString: string
}

export const getViewBADetails = ({ token, href, queryString }: TViewBADetailsParams) => {
    const hydraHref = toHydraHref(href)
    const url = `${hydraHref}${queryString}`

    return axios.get(url, createHydraRequest(token))
}
